import React from "react";
import PropTypes from "prop-types";
import ReactLoading from "react-loading";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CurrencyTable from "components/Table/CurrencyTable";

import httpr from "lib/httpRequest";
import { BASE_URL } from "lib/config";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";

class TerminalDetail extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      value: 0,
      cash: [],
      coin: [],
      isLoading: true,
      isKisanMachine: false,
    };
  }

  componentDidMount() {
    this._isMounted = true;
    this.getTerminalDetails();
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.terminal.TERMINAL_ID !== this.props.terminal.TERMINAL_ID
      || prevProps.terminal.TERMINAL_NAME !== this.props.terminal.TERMINAL_NAME
      ) {
      this.getTerminalDetails();
      if (this._isMounted === true) {
        this.setState({ isLoading: true });
      }
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getTerminalDetails = () => {
    const token = localStorage.getItem("token");
    const fetch = httpr(token);

    // Fetch data from api
    fetch
      .post(`${BASE_URL}/api/terminal/details/`, {
        terminal: this.props.terminal,
      })
      .then((response) => {
        const isKisanMachine = this.props.terminal.model === "100" ? true : false;
        if (this._isMounted === true) {
          this.setState({
            cash: response.data.cash,
            coin: response.data.coin,
            isLoading: false,
            isKisanMachine: isKisanMachine
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = (index) => {
    this.setState({ value: index });
  };

  render() {
    const { classes, terminal } = this.props;

    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12} md={this.state.isKisanMachine === true ? 12 : 6}>
            <Card>
              <CardHeader color="success">
                <h4 className={`${classes.cardTitleWhite} material-icons`}>
                  {terminal.TERMINAL_NAME} - Cash
                </h4>
              </CardHeader>
              <CardBody>
                {this.state.isLoading === true ? (
                  <ReactLoading
                    type="spin"
                    color="#000000"
                    style={{
                      width: "20%",
                      margin: "auto",
                    }}
                  />
                ) : (
                  <CurrencyTable coins={false} tableData={this.state.cash} />
                )}
              </CardBody>
            </Card>
          </GridItem>
          {this.state.isKisanMachine === false && (
          <GridItem xs={12} sm={12} md={6}>
            <Card>
              <CardHeader color="success">
                <h4 className={`${classes.cardTitleWhite} material-icons`}>
                  {terminal.TERMINAL_NAME} - Coin
                </h4>
              </CardHeader>
              <CardBody>
                {this.state.isLoading === true ? (
                  <ReactLoading
                    type="spin"
                    color="#000000"
                    style={{
                      width: "20%",
                      margin: "auto",
                    }}
                  />
                ) : (
                  <CurrencyTable coins={false} tableData={this.state.coin} />
                )}
              </CardBody>
            </Card>
          </GridItem>
          )}
        </GridContainer>
      </div>
    );
  }
}

TerminalDetail.propTypes = {
  classes: PropTypes.object.isRequired,
  terminal: PropTypes.object.isRequired,
};

export default withStyles(dashboardStyle)(TerminalDetail);



// WEBPACK FOOTER //
// ./src/components/Terminal/TerminalDetail.jsx